<template>
	<div>
		<RadioGroup
			v-model="yesNo"
			:options="yesNoOptions"
			@change="emitChangeEvent"
		/>
		<div v-if="extraDataEligible" class="sections mt-4">
			<section>
				<h3>Wohin würdest du übersiedeln?</h3>
				<CharacteristicSelectInline
					v-model="geo"
					title="Bitte wähle aus wohin du übersiedeln würdest"
					:characteristic-type="meta.geoType"
					:characteristic-items="geoItems"
					:nothing-allowed="{
						text: 'Ich würde überall hin übersiedeln'
					}"
					show-multiple-hint
					:label-type="labelTypeApplication"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>
<script>
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";
import {mapState} from "vuex";
import RadioGroup from "@/vue/common/form/RadioGroup";
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline"
import {APPLICATION} from "@/helper/characteristic/Label";
import {handle} from "@/helper/characteristic/Level";
import {onlyCountries} from "@/helper/characteristic/geo/Filter";
import * as Geo from "@/helper/characteristic/geo/Geo";

export default {

	components: {
		RadioGroup,
		FormGroup,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		label: {
			type: String,
			required: false,
		},
	},

	data ()
	{
		return {
			yesNo: this.value?.yesNo,
			yesNoOptions: Object.freeze([
				{value: true, text: 'Ja'},
				{value: false, text: 'Nein'},
			]),
			geo: this.value?.geo,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		labelTypeApplication ()
		{
			return APPLICATION;
		},
		yesNoValid ()
		{
			return isDefined(this.yesNo);
		},
		extraDataEligible ()
		{
			return this.yesNo === true;
		},
		geoItems ()
		{
			return handle(
				onlyCountries(this.meta.geo, Geo.DACH()),
				1
			);
		},
		geoValid ()
		{
			return !this.extraDataEligible || isDefined(this.geo);
		},
		dataValid ()
		{
			return this.yesNoValid
				&& this.geoValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				yesNo: this.yesNo,
				geo: this.extraDataEligible
					? this.geo
					: undefined,
			});
		}
	}
}
</script>
